import React, { useState, useEffect } from "react";
import { Panel } from "baseui/accordion";
import { TREE_ITEM_TYPES } from "../../constants/AppEnums";
import NumericInputTemplate from "../../components/numeric-input-template/NumericInputTemplate";
import MultioptionInputTemplate from "../../components/multioption-input-template/MultioptionInputTemplate";
import TextInputTemplate from "../../components/text-input-template/TextInputTemplate";


const GenericInputTemplate = ({ item, ...props }) => {
  switch (item.type) {
    case TREE_ITEM_TYPES.NUMERIC:
      return <NumericInputTemplate {...item} {...props} />;
    case TREE_ITEM_TYPES.MULTIOPTION:
      return <MultioptionInputTemplate {...item} {...props} />;
    case TREE_ITEM_TYPES.TEXT:
      return <TextInputTemplate {...item} {...props} />;
    default:
      return <div></div>;
  }
};

export default function TemplateInputItem({handleItemPropsChanged, ...props}) {
  const [item, setItem] = useState(props.item);
  const [expanded, setExpanded] = React.useState(props.item.isSelected);
  const [errors, setErrors] = useState({
    common: { name: false, displayName: false, description: false },
    numeric: { defaultValue: false, minValue: false, maxValue: false, step: false },
    multioption: { defaultValue: false, optionsList: false },
    text: { defaultValue: false },
  });


  useEffect(() => {
    setItem(props.item);
  }, [props.item]);
 
  const validateCommonValues = (updatedItem) => {
    let isError = false;
    let commonErrors = {
      name: false,
      displayName: false,
      description: false,
    };
  
    const { id, name, displayName, description } = updatedItem;
  
    const nameExists = (name, id) => {
      return (props.allGroups || []).some(
        (group) => group.children && group.children.some(
          (child) => child.name === name && child.id !== id
        )
      );
    };
  
    const alphaNumericWithoutSpace = /^[a-zA-Z0-9_]+$/;
  
    if (!name.match(alphaNumericWithoutSpace)) {
      commonErrors.name = true;
      isError = true;
    } else if (nameExists(name, id)) {
      commonErrors.name = true;
      isError = true;
    }
  
    // Add similar validation for displayName and description
    if (!displayName || displayName.length === 0) {
      commonErrors.displayName = true;
      isError = true;
    }
  
    // if (!description || description.length === 0) {
    //   commonErrors.description = true;
    //   isError = true;
    // }
  
    // Update the errors state with the new commonErrors
    setErrors(prevErrors => ({
      ...prevErrors,
      common: commonErrors
    }));
  
    return isError;
  };
  const validateMultiOptionValues = (updatedItem) => {
    let isError = false;
    let multiOptionErrors = {
      defaultValue: false,
      optionsList: false,
    };
    const { optionsList, defaultValue } = updatedItem;
    if (!optionsList.length) {
      multiOptionErrors.optionsList = true;
      isError = true;
    } else {
      multiOptionErrors.optionsList = false;      
    }

    if (!optionsList.includes(defaultValue)) {
      multiOptionErrors.defaultValue = true;
      isError = true;
    } else {
      multiOptionErrors.defaultValue = false;
    }

    setErrors(prevErrors => ({
      ...prevErrors,
      multioption: multiOptionErrors
    }));

    return isError;
  };
  const validateNumericValues = (updatedItem) => {
    let isError = false;
    let numericErrors = {
      defaultValue: false,
      minValue: false,
      maxValue: false,
      step: false,
    };
  
    // Assuming updatedItem has defaultValue, minValue, maxValue, and step
    const { defaultValue, minValue, maxValue, step } = updatedItem;
    if (minValue == null) {
      numericErrors.minValue = true;
      isError = true;
    }

    if (maxValue == null) {
      numericErrors.maxValue = true;
      isError = true;
    }

    if (defaultValue == null) {
      numericErrors.defaultValue = true;
      isError = true;
    }
    if (step == null) {
      numericErrors.step = true;
      isError = true;
    }   
  
    if (Number(maxValue) < Number(minValue)) {
      numericErrors.maxValue = true;
      isError = true;
    } else {
      numericErrors.maxValue = false;
    }
  
    if (Number(defaultValue) < Number(minValue) || Number(defaultValue) > Number(maxValue)) {
      numericErrors.defaultValue = true;
      isError = true;
    } else {
      numericErrors.defaultValue = false;
    }
  
    // Additional validation for the 'step' field if necessary
    // Example:
    if (step <= 0) {
      numericErrors.step = true;
      isError = true;
    }
  
    // Update the errors state with the new numericErrors
    setErrors(prevErrors => ({
      ...prevErrors,
      numeric: numericErrors
    }));
    return isError;
  };
  const handleItemChange = (itemType, updatedItem) => {
    let hasCommonError = validateCommonValues(updatedItem);
    let hasSpecificError = false;

    switch (itemType) {
      case TREE_ITEM_TYPES.NUMERIC:
        hasSpecificError = validateNumericValues(updatedItem);
        break;
      case TREE_ITEM_TYPES.MULTIOPTION:
        hasSpecificError = validateMultiOptionValues(updatedItem);
        break;
      case TREE_ITEM_TYPES.TEXT:
        // Call validateTextValues here        
        break;
        default:
          break;

      // ... other cases
    }

    if (!hasCommonError && !hasSpecificError) {
      handleItemPropsChanged(updatedItem);
    } 
  };
 
  return (
    <Panel
      expanded={expanded}
      key={item.id}
      title={item.displayName}
      onChange={({ key, expanded }) => {
        setExpanded(expanded);
      }}
      overrides={{
        Header: {
          style: ({ $theme, $color }) => ({
            backgroundColor: item.isSelected
              ? $theme.colors.primary
              : $theme.colors.white,
            color: item.isSelected
              ? $theme.colors.white
              : $theme.colors.primary,
            ":hover": {
              color: item.isSelected
                ? $theme.colors.white
                : $theme.colors.primary,
            },
          }),
        },
        ToggleIcon: {
          style: ({ $theme }) => ({
            color: item.isSelected
              ? $theme.colors.white
              : $theme.colors.primary,
          }),
        },
      }}
    >
      <GenericInputTemplate {...props} errors={errors}  handleItemPropsChanged={handleItemChange} />
    </Panel>
  );
}

//  connect(null, null)(TemplateInputItem);
